// Action type IDs (allows action type names to be minified)
export const INPUT_FOCUS = 0;
export const INPUT_BLUR = 1;
export const INPUT_CHANGE = 2;
export const INPUT_ARROW_UP = 3;
export const INPUT_ARROW_DOWN = 4;
export const INPUT_ESCAPE = 5;
export const INPUT_ENTER = 6;
export const SUGGESTION_MOUSE_CLICK = 7;
export const SUGGESTION_MOUSE_ENTER = 8;
export const HAS_SUGGESTIONS_CHANGED = 9;

export type Action =
  | { type: typeof INPUT_FOCUS }
  | { type: typeof INPUT_BLUR }
  | { type: typeof INPUT_CHANGE }
  | { type: typeof INPUT_ARROW_UP }
  | { type: typeof INPUT_ARROW_DOWN }
  | { type: typeof INPUT_ESCAPE }
  | { type: typeof INPUT_ENTER }
  | { type: typeof SUGGESTION_MOUSE_CLICK }
  | { type: typeof SUGGESTION_MOUSE_ENTER; value: number }
  | { type: typeof HAS_SUGGESTIONS_CHANGED };
